export default __webpack_public_path__ + "static/media/gallery_10.46148e24.jpg";